import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  unStampButton: {
    backgroundColor: theme.palette.red,
  },
}));
